import styled from "@emotion/styled";

export const Form = styled.form`
  max-width: 600px;
  width: 95%;
  margin: 5rem auto 0 auto;

  font-size: 2rem;
  @media (max-width: 768px) {
    font-size: inherit !important;
  }
  text-align: center;
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: space-between;

  fieldset {
    margin: 1rem 0;
    border: 1px solid #e1e1e1;
    font-size: 2rem;
    padding: 2rem;
    @media (max-width: 768px) {
        font-size: inherit !important;
        margin: 0 auto;
        padding: 0;
      }
  }

  
`;

export const Field = styled.div`
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    font-size: inherit !important;
    width: 100%;
  }
  label {
    flex: 0 0 150px;
    font-size: 1.8rem;
    @media (max-width: 768px) {
        font-size: inherit !important;
        width: 100%;
      }
  }

  input,
  textarea {
    flex: 1;
    padding: 1rem;
    @media (max-width: 768px) {
        font-size: inherit !important;
        width: 100%;
      }
  }
  textarea {
    height: 400px;
    @media (max-width: 768px) {
        font-size: inherit !important;
        width: 100%;
      }
  }

  
`;

export const InputSubmit = styled.input`
  background-color: var(--primary);
  width: 100%;
  padding: 1.5rem;
  text-align: center;
  color: #fff;
  font-size: 1.8rem;
  border-radius: 25px;
  text-transform: uppercase;
  border: none;
  font-family: "PT Sans", sans-serif;
  font-weight: 700;
  margin-bottom: 1rem;
  &:hover {
    cursor: pointer;
    transform: translateY(1) scale(1);
    background: var(--secondary);
  }

  @media (max-width: 768px) {
    font-size: inherit !important;
    
  }
`;

export const Select = styled.select`
  flex: 1;
  padding: 1rem;
  appearance: none;
  border: 1 solid gray;
  background: var(--white);
`;

export const Error = styled.p`
background-color: red;
padding: 1rem;
font-family: 'PT Sans', sans-serif;
font-weight: 700;
font-size: .8rem;
color: #FFF;
text-align: center;
text-transform: uppercase;
`;
